import axios from 'axios'

let token = ''
export function getCurrentUser () {
  return axios.get('https://api.spotify.com/v1/me', {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}

export function createPlaylist (userId, name) {
  return axios.post(`https://api.spotify.com/v1/users/${userId}/playlists`, {
    name: name,
    description: 'Playlist created by Rockolify',
    public: false
  },
  {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  })
}

export function getSong (songId) {
  return axios.get(`https://api.spotify.com/v1/tracks/${songId}`, {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  })
}

export function addSongToPlaylist (userId, playlistId, songUri) {
  let url = `https://api.spotify.com/v1/users/${userId}/playlists/${playlistId}/tracks`
  return axios.post(url, {
    uris: [
      songUri
    ]
  },
  {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  })
}

export function initPlaylistStream (playlistUri) {
  let url = 'https://api.spotify.com/v1/me/player/play'
  return axios.put(url, {
    context_uri: playlistUri,
    offset: {position: 0}
  },
  {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  })
}

export function deactiveShuffleMode () {
  let url = 'https://api.spotify.com/v1/me/player/shuffle?state=false'
  return axios.put(url, {}, {
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  })
}

export function getToken () {
  return token
}

export function setToken (newToken) {
  token = newToken
}



// WEBPACK FOOTER //
// ./src/utils/spotify-driver.js